const normalizeUrl = (str: string): string =>
    str.replace(/[/]+/g, '/').replace(/\/\?/g, '?').replace(/\/#/g, '#').replace(/:\//g, '://');

export const pathNoQueryHash = (path: string): string => {
    const queryIndex = path.indexOf('?');
    const hashIndex = path.indexOf('#');

    let result = path;

    if (queryIndex > -1 || hashIndex > -1) {
        result = path.substring(0, queryIndex > -1 ? queryIndex : hashIndex);
    }

    return result;
};

/**
 * Simple URL join. Join all string parameters as a URL. Does a simple normalizes aswell.
 * @returns {string} the url
 */
export function join(...stringsToJoin: Array<string>): string {
    const args = [].slice.call(stringsToJoin, 0).filter((val) => val !== undefined && val !== '');

    return normalizeUrl(args.join('/'));
}

const noAccents = (str: string): string => {
    if (!str) {
        return '';
    }

    return str
        .toLowerCase()
        .replace(/[àáâãäåāąă]/g, 'a')
        .replace(/[çćčĉċ]/g, 'c')
        .replace(/[ďđð]/g, 'd')
        .replace(/[èéêëēęěĕė]/g, 'e')
        .replace(/[ƒſ]/g, 'f')
        .replace(/[ĝğġģ]/g, 'g')
        .replace(/[ĥħ]/g, 'h')
        .replace(/[ìíîïīĩĭįı]/g, 'i')
        .replace(/[ĳĵ]/g, 'j')
        .replace(/[ķĸ]/g, 'k')
        .replace(/[łľĺļŀ]/g, 'l')
        .replace(/[ñńňņŉŋ]/g, 'n')
        .replace(/[òóôõöøōőŏœ]/g, 'o')
        .replace(/[Þþ]/g, 'p')
        .replace(/[ŕřŗ]/g, 'r')
        .replace(/[śšşŝș]/g, 's')
        .replace(/[ťţŧț]/g, 't')
        .replace(/[ùúûüūůűŭũų]/g, 'u')
        .replace(/[ŵ]/g, 'w')
        .replace(/[ýÿŷ]/g, 'y')
        .replace(/[žżź]/g, 'z')
        .replace(/[ß]/g, 'ss')
        .replace(/[&]/g, 'och')
        .replace(/[–—]/g, '-')
        .replace(/[/]/g, '-');
};

const justCharacters = (str: string) =>
    noAccents(str)
        .replace(/[^\w\s-]/g, '') // remove non-word [a-z0-9_], non-whitespace, non-hyphen characters
        .replace(/^-+|-+$/g, ''); // remove leading, trailing -

export const updateQuery = (query: any, params: any): any => ({ ...query, ...params });

export const slugify = (str: string): string => justCharacters(noAccents(str).replace(/[\s:_\-,.]+/g, '-')); // swap any length of whitespace, underscore, hyphen characters with a single - or , or .

export const formatUrl = (path: string, query = {}): string => {
    if (!path) {
        return '';
    }

    // TODO: encodeURIComponent and check that incoming queryparams are not already encoded
    const qs = Object.keys(query)
        .filter((key) => query[key] !== undefined && query[key] !== null)
        .map((key) => `${key}=${query[key]}`)
        .join('&');
    const separator = path.includes('?') ? '&' : '?';

    return `${path}${qs ? separator : ''}${qs}`;
};

export const isValidURL = (url: string): boolean => {
    try {
        decodeURI(url);
    } catch (e) {
        return false;
    }

    return true;
};

export const removeLeadingForwardSlashes = (path: string): string => {
    if (!path) {
        return path;
    }

    return path.replace(/^[/]+/, '');
};

export const isExternalURL = (url: string, localDomain = 'www.svtplay.se'): boolean => {
    const matches = url.match(/^(?:(?:https?:)?\/\/)?([^/?#]+)(?:[/?#]|$)/i);

    return matches && matches.length > 1 && matches[1] !== localDomain;
};

export const isVideoUrl = (url: string): boolean => {
    if (typeof url === 'string') {
        return url.match(/^\/video\/\d+/gi) !== null;
    }

    return false;
};

export const toLinkUrl = (url: string): string =>
    url && url.startsWith('https://www.svtplay.se') ? url.replace('https://www.svtplay.se', '') : url;

export const jumpToHash = (hash: string): void => {
    if (hash && typeof hash === 'string' && hash !== '') {
        setTimeout(() => {
            const id = hash.replace('#', '');
            const element = document.getElementById(id);

            if (element) {
                element.scrollIntoView();
                element.focus();
            }
        }, 0);
    }
};
